module.exports = __webpack_public_path__ + "static/img/CODY-WALKER.139ef50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CODY-WALKER.jpg
// module id = TJpG
// module chunks = 0